import {renderInputField} from "../../common/RenderInputField";
import React, {useState,useEffect} from "react";
import LanguageStringResolver from "../../fields/language/LanguageStringResolver";
import {getLineTypeMappingLabelById} from "../../../utils/manualDocuments/lineListingTypeMappingForLabel";
import {ManualDocumentDocumentType} from "../../../utils/enums";
import _ from "underscore";
import VATNUMBER_CONTROLLER from "../../../controllers/vatNumbers";
import {connect} from "react-redux";
import CONTENT_CONTROLLER from "../../../controllers/content";

const EcListingForm = props => {
    const getInitialValues = () => ({
        vatNumber: "",
        amount: "",
        listingType: "",
        lineListingType: 1,
        serviceCode: "",
        customerName: "",
        originalTradingPartnerVATNumber: "",
        originalTradingPartnerName: "",
        coSDate: props?.invoiceDate || props?.selectedValues?.invoiceDate || ""
    });

    const [formValues, setFormValues] = useState({
        ...getInitialValues,
        coSDate: props?.invoiceDate || props?.selectedValues?.invoiceDate || '', // Set initial value from props
    })
    const [showError, setShowError] = useState(false);
    const [vatNumberIsValid, setVatNumberIsValid] = useState(true);

     // State to manage field disabilities
     const [fieldsEnabled, setFieldsEnabled] = useState({
        customerName: false,
        originalTradingPartnerVATNumber: false,
        originalTradingPartnerName: false,
        coSDate: false
    });
    
    const isServiceCodeRequired = formValues.lineListingType === 3 && props.selectedValues?.country === "IT";
    const requiredFields = ["vatNumber", "amount", ...(isServiceCodeRequired ? ["serviceCode"] : [])];

    const handleInputChange = e => {
        const { name, value } = e.target;
        setFormValues(prev => ({
            ...prev,
            [name]: value,
        }));
        
        // Update parent state if coSDate changes
        if (name === 'coSDate' && props.setInvoiceDate) {
            props.setInvoiceDate(value);
        }
    };
    
    useEffect(() => {
        props.onGetVATNumberRules();
    }, [])
    
    // Update local state when prop invoiceDate changes
    useEffect(() => {
        if (props.invoiceDate) {
            setFormValues(prev => ({
                ...prev,
                coSDate: props.invoiceDate
            }));
        }
    }, [props.invoiceDate])
    
    const handleOnBlurChange = () => {
        // check value of vat-number
        validateVATNumber(formValues.vatNumber);
    }

    const handleRadioInputChange = e => {
        const { name, value } = e.target;
        const selectedValue = Number(value);
        setFormValues(prev => ({
            ...prev,
            [name]: Number(value),
            coSDate: props?.invoiceDate || prev.coSDate || props?.selectedValues?.invoiceDate
        }));

        // Enable/disable fields based on listing type
        switch (selectedValue) {
            case 11:
                setFieldsEnabled({
                    customerName: true,
                    originalTradingPartnerVATNumber: true,
                    originalTradingPartnerName: true,
                    coSDate: false
                });
                break;
                
            case 9:
            case 10:
                setFieldsEnabled({
                    customerName: true,
                    originalTradingPartnerVATNumber: false,
                    originalTradingPartnerName: false,
                    coSDate: false
                });
                break;
                
            default:
                setFieldsEnabled({
                    customerName: false,
                    originalTradingPartnerVATNumber: false,
                    originalTradingPartnerName: false,
                    coSDate: false
                });
                break;
        }
        
        // Clear values when disabled
        setFormValues(prev => ({
            ...prev,
            customerName: "",
            originalTradingPartnerVATNumber: "",
            originalTradingPartnerName: "",
            coSDate: props?.invoiceDate || props?.selectedValues?.invoiceDate || ""
        }));
    }

    const getRegExPattern = () => {
       return _.find(props.vatValidationRules, elem => elem.key === props.selectedValues.country)?.value;
    }

    const validateVATNumber = vatNumber => {
        const res = getRegExPattern()?.test(vatNumber);
        if(!res) setVatNumberIsValid(false);
        if(res)
        {
            const callback = (response) => {
                if (response.vatNumber === formValues.vatNumber) {
                    setVatNumberIsValid(response.technicalCheck);
                } else {
                    setVatNumberIsValid(false);
                }
            };
            //If VAT number pass reg ex then perform deep check (SaaS API)
            props.doValidateVATNumber(vatNumber.trim(), callback);
        }
    }

    const IsValidForm = () => {
        let isValid = true;
        requiredFields.forEach(field => {
            const value = formValues[field];
            if (!value || value.toString().trim() === '') {
                isValid = false;
            }
        });
        return isValid;
    };
    

    const mapToAddKeyValues = data => {
        if (!props.enableCoSGrid) {
            data = data.filter(obj => ![9, 10, 11].includes(obj.value));
        }
        return data
            .map(obj => {
                const label = getLineTypeMappingLabelById(obj.value);
                return label ? { label: `${obj.value}-${label}`, value: obj.value } : null;
            })
            .filter(Boolean); // This removes any null values from the array
    };
    
    const onFormSubmit = () => {
        if(!IsValidForm()){
            setShowError(true);
        } else {
            setShowError(false);
            setVatNumberIsValid(true) // Rest input field valid for vatNumber
            props.appendFormData({...formValues, listingType: props.selectedValues.documentType ===  ManualDocumentDocumentType.SALES ? 0 : 1});
            onReset();
        }
    }

    const onReset = () => {
        setShowError(false);
        setFormValues(getInitialValues());
        setFieldsEnabled({
            customerName: false,
            originalTradingPartnerVATNumber: false,
            originalTradingPartnerName: false,
            coSDate: false
        }); 
    }

    const validationRules = [
        { key: 'vatNumber', errorMsg: 'ecListing_manual_document_vat_number_err_msg' },
        { key: 'amount', errorMsg: 'ecListing_manual_document_amount_err_msg' },
        ...(isServiceCodeRequired ? [{ key: 'serviceCode', errorMsg: 'ecListing_manual_document_service_code_err_msg' }] : [])
    ];

    const validationErrorSection = () => {
        
        // Map through the array directly instead of using Object.entries
        return validationRules.map(rule => {
            const isEmpty = !formValues[rule.key] || 
                        formValues[rule.key].toString().trim().length === 0;

            // Only show errors if showError is true
            if (!showError) return null;

            return isEmpty && (
                <s-alert 
                    key={rule.key} 
                    status="error" 
                    data-testid={`${rule.key}_err_msg`} 
                    nodismiss={true}
                    role="alert"
                >
                    <LanguageStringResolver string={rule.errorMsg} />
                </s-alert>
            );
        });
    };
    
    return (
    <>
        <h3><LanguageStringResolver string='manual_document_ecListing_form_title'/></h3>
        <div>
            <label className='mb15'>
                <LanguageStringResolver string='manual_document_ecListing_description'/>
            </label>
        </div>
        <s-container className="mb50 mt20" data-testid="ec-listing-form">
            {validationErrorSection()}
            <form>
                <s-row>
                    <s-col span="auto" data-testid="vatNumber">
                        <label htmlFor="vatNumber" className="required">
                            <LanguageStringResolver string="ecListing_manual_document_vat_number"/>
                        </label>
                        <input data-testid="vatNumber-input" type="text" id="vatNumber" name="vatNumber" value={formValues.vatNumber || ''} className={ vatNumberIsValid ? "valid" :"invalid"} pattern={getRegExPattern()} onChange = { e => handleInputChange(e) } onBlur = { () => handleOnBlurChange() }/>                    </s-col>
                </s-row>
                {renderInputField("amount", "ecListing_manual_document_amount", formValues, handleInputChange, "number", true)}
                    {props.enableCoSGrid && (
                        <>
                            {renderInputField("customerName", "ecListing_manual_document_customerName", formValues, handleInputChange, "text", false, !fieldsEnabled.customerName)}
                            {renderInputField("originalTradingPartnerVATNumber", "ecListing_manual_document_originalTradingPartnerVATNumber", formValues, handleInputChange, "text", false, !fieldsEnabled.originalTradingPartnerVATNumber)}
                            {renderInputField("originalTradingPartnerName", "ecListing_manual_document_originalTradingPartnerName", formValues, handleInputChange, "text", false, !fieldsEnabled.originalTradingPartnerName)}
                            {renderInputField("coSDate", "ecListing_manual_document_coSDate", formValues, handleInputChange, "date", false, !fieldsEnabled.coSDate)}
                        </>)}
                <s-row>
                    <s-col span="auto" data-testid="lineListingType">
                        <fieldset>
                            <legend id="lineListingType-label" className="required"><LanguageStringResolver
                                string='ecListing_manual_document_listing_type'/></legend>
                            {props.listingLineType && mapToAddKeyValues(props.listingLineType).map(obj => {
                                return (<React.Fragment key={obj.value}>
                                    <input type="radio"
                                           id={obj.label}
                                           aria-checked="false"
                                           data-testid="lineListingType-input" 
                                           key={obj.value}
                                           name="lineListingType" 
                                           value={obj.value}
                                           checked={formValues.lineListingType === obj.value}
                                           onClick={handleRadioInputChange}/>
                                    <label htmlFor={obj.label}>{obj.label}</label>
                                    <br/>
                                </React.Fragment>)
                            })
                            }
                        </fieldset>
                    </s-col>
                </s-row>
                { renderInputField("serviceCode", "ecListing_manual_document_service_code", formValues, handleInputChange, "text", isServiceCodeRequired, (formValues.lineListingType !== 3 && formValues.lineListingType !== 4))}
            </form>
            <button className="primary mt15" data-testid="add-button" onClick={onFormSubmit}>
                <LanguageStringResolver string='ecListing_manual_document_add_button'/></button>
        </s-container>
    </>
    );
};


EcListingForm.defaultProps = {
    vatNumber: "",
    amount: 0
};

const mapStateToProps = state => {
    return {
        vatValidationRules: state.content && state.content.vatNumberRules,
        enableCoSGrid: state.featureFlag?.data?.EnableCoSGrid
    };
}

const mapDispatchersToProps = dispatch => {
    return {
        doValidateVATNumber: (vatNumber, callback) => {
            dispatch(VATNUMBER_CONTROLLER.doValidateVATNumber(vatNumber, callback));
        },
        onGetVATNumberRules : () => {
            dispatch(CONTENT_CONTROLLER.getVATNumberRules());
        },
    }
}
export default connect(mapStateToProps, mapDispatchersToProps)(EcListingForm);